import request from './axiosClient';

const URL_SHOP = '/shop';

export function fetchShopListAPI(token: string) {
  return request({
    url: URL_SHOP,
    method: 'get',
    token,
  });
}
